export default __webpack_public_path__ + "static/media/gm-mg-girl.3b262601.webp";